module.exports = __webpack_public_path__ + "static/media/tick.f89de7a7.svg";